/* KETTLER — Großansicht der Produktbilder (PDP Kaufzone)
 *
 * Klick/Tipp auf das Hauptbild öffnet die Bilder der gewählten Farbe als Vollbild-Dialog.
 * Wischen oder Pfeile blättern, Tipp/Klick auf das Bild vergrößert (2,5-fach) und macht es
 * per Finger bzw. Mausbewegung verschiebbar, zweiter Tipp verkleinert. Esc/X schließt.
 * Beschriftungen kommen übersetzt aus data-Attributen der Section.
 */
(function () {
  'use strict';

  function init(section) {
    var views = section.querySelectorAll('.k-view');
    if (!views.length) return;
    var t = section.dataset;
    var dlg = document.createElement('dialog');
    dlg.className = 'k-lb';
    dlg.innerHTML =
      '<button type="button" class="k-lb__close" aria-label="' + t.lbClose + '">&times;</button>' +
      '<button type="button" class="k-lb__nav k-lb__prev" aria-label="' + t.lbPrev + '">&#8249;</button>' +
      '<div class="k-lb__stage"><img class="k-lb__img" alt=""></div>' +
      '<button type="button" class="k-lb__nav k-lb__next" aria-label="' + t.lbNext + '">&#8250;</button>' +
      '<p class="k-lb__count" aria-live="polite"></p>';
    document.body.appendChild(dlg);
    var stage = dlg.querySelector('.k-lb__stage');
    var img = dlg.querySelector('.k-lb__img');
    var count = dlg.querySelector('.k-lb__count');
    var liste = [], pos = 0;

    function bilder() {
      var out = [];
      views.forEach(function (v) {
        var i = v.querySelector('img');
        if (i && v.dataset.aktiv !== '0') out.push(i);
      });
      return out;
    }
    function gross(src) { return src.replace(/([?&])width=\d+/, '$1width=2400'); }
    function zeigen(n) {
      pos = (n + liste.length) % liste.length;
      stage.classList.remove('is-zoom');
      img.style.width = '';
      img.src = gross(liste[pos].currentSrc || liste[pos].src);
      img.alt = liste[pos].alt || '';
      count.textContent = t.lbStatus.replace('%i', pos + 1).replace('%n', liste.length);
      dlg.classList.toggle('is-single', liste.length < 2);
    }
    function zoom(e) {
      var an = !stage.classList.contains('is-zoom');
      var r = img.getBoundingClientRect();
      var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      /* Zoom auf die Originalgröße, mindestens doppelt so groß wie angezeigt. */
      var sichtbarW = Math.min(r.width, r.height * img.naturalWidth / img.naturalHeight); /* object-fit: contain */
      img.style.width = an ? Math.max(img.naturalWidth, sichtbarW * 2) + 'px' : '';
      stage.classList.toggle('is-zoom', an);
      if (an) {
        stage.scrollLeft = fx * stage.scrollWidth - stage.clientWidth / 2;
        stage.scrollTop = fy * stage.scrollHeight - stage.clientHeight / 2;
      }
    }

    views.forEach(function (v) {
      var i = v.querySelector('img');
      if (!i) return;
      i.style.cursor = 'zoom-in';
      i.addEventListener('click', function () {
        liste = bilder();
        var start = liste.indexOf(i);
        if (start < 0) return;
        dlg.showModal();
        zeigen(start);
      });
    });
    img.addEventListener('click', zoom);
    stage.addEventListener('mousemove', function (e) {
      if (!stage.classList.contains('is-zoom') || e.buttons) return;
      var r = stage.getBoundingClientRect();
      stage.scrollLeft = (e.clientX - r.left) / r.width * (stage.scrollWidth - stage.clientWidth);
      stage.scrollTop = (e.clientY - r.top) / r.height * (stage.scrollHeight - stage.clientHeight);
    });
    dlg.querySelector('.k-lb__close').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('.k-lb__prev').addEventListener('click', function () { zeigen(pos - 1); });
    dlg.querySelector('.k-lb__next').addEventListener('click', function () { zeigen(pos + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') zeigen(pos - 1);
      if (e.key === 'ArrowRight') zeigen(pos + 1);
    });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null || stage.classList.contains('is-zoom')) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) zeigen(pos + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  function start() { document.querySelectorAll('[data-kettler-zone="kaufzone"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
